var render, staticRenderFns
import script from "./DraggableItem2.vue?vue&type=script&lang=js"
export * from "./DraggableItem2.vue?vue&type=script&lang=js"
import style0 from "./DraggableItem2.vue?vue&type=style&index=0&id=08756138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08756138",
  null
  
)

export default component.exports